export default __webpack_public_path__ + "static/media/_DSC0629.03607201.JPG";